module.exports = __webpack_public_path__ + "img/Order-step-m.e5dec290.png";